export default __webpack_public_path__ + "ade5c0ac88ea43b82debf6c69833af8b.png";